import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";
import Buttons from "../../../../components/ui/button/Buttons";

const initState = {
  valName: "",
  planYearBegin: "",
  planYearEnd: "",
  wordDocID: "",
  reportTemplateID: "",
  copyValID: "",
  xmlReportId: "",
};

export const clientValuationDetailsFormConfig = {
  name: "Client Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "valName",
          label: "Name",
          Field_Name: "name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "valName",
          fieldSetting: {
            placeholder: "Please enter name",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-8 col-md-8",
          },
        },

        {
          id: "planYearBegin",
          label: "Plan Year Begin",
          Field_Name: "begining plan year",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "planYearBegin",
          fieldSetting: {
            placeholder: "Select plan begining year",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4",
          },
        },

        {
          id: "copyValID",
          label: "Valuation To Copy",
          Field_Name: "valuation to copy",
          fieldType: FormFieldTypes.SELECT,
          dataField: "copyValID",
          fieldSetting: {
            placeholder: "Please select valuation to copy",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-8 col-md-8",
          },
        },

        {
          id: "planYearEnd",
          label: "Plan Year End",
          Field_Name: "ending plan year",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "planYearEnd",
          fieldSetting: {
            placeholder: "Select plan ending year",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4",
          },
        },
        {
          id: "reportTemplateID",
          label: "Template",
          Field_Name: "template",
          fieldType: FormFieldTypes.SELECT,
          dataField: "reportTemplateID",
          fieldSetting: {
            placeholder: "Please select template",
            allowSpace: true,
            isDisable: false,
            isFormControl: true,
            isTemplateBtnDisable: false,
            formControltemplate: [
              <Buttons
                actionName={"ADD"}
                buttonText={"Add Set"}
                buttonTypeClassName="btn blue-btn w-full ml-2 first-input-btn"
              />,
              <Buttons
                actionName={"REMOVE"}
                buttonText={"Remove Set"}
                buttonTypeClassName="btn secondary-btn w-full ml-2 first-input-btn"
              />,
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 select-with-btn two-button",
          },
        },
      ],
    },
  ],
};
